module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-12.6ce494c1.jpg";